import { render, staticRenderFns } from "./RoadDetailsForm.vue?vue&type=template&id=2cac5ef1"
import script from "./RoadDetailsForm.vue?vue&type=script&lang=js"
export * from "./RoadDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports